"use client";
import { Grid, GridItem } from "@/components/Grid/Grid.component";
import Image from "@/components/Image/Image.component";
import { Typography } from "@/components/Typography/Typography.component";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import {
  ClientFields,
  LogoListPropsModel,
  PartnerFields,
} from "./LogoList.model";

const LogoList = ({
  title,
  logoStatic,
  clientsCollection: items,
}: LogoListPropsModel) => {
  const [cssClass, setCssClass] = useState("grid-rows-2");
  const [logos, setLogos] = useState(items);
  function insertRandomUntilDivisibleBy2And3(
    items: ClientFields[] | PartnerFields[],
  ) {
    if (logoStatic) return items;
    while (items.length % 6 !== 0) {
      const randomIndex = Math.floor(Math.random() * items.length);
      const randomElement = items[randomIndex];
      if ("thumbnail" in randomElement && "color" in randomElement) {
        items.push(randomElement as ClientFields);
      }
    }
    return items;
  }
  useEffect(() => {
    if (logoStatic) setLogos(items);
    else setLogos(insertRandomUntilDivisibleBy2And3(items));
    if (items.length <= 6) setCssClass("grid-rows-1");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid hasPadding={false}>
      <GridItem span={{ mobile: 4, tablet: 8, desktop: 12 }}>
        <div className="bg-black py-40 max-md:py-20">
          <Typography.H4 className="flex w-screen justify-center text-white">
            {title}
          </Typography.H4>
          {logoStatic ? (
            <div
              className={cn(
                cssClass,
                `grid grid-flow-row grid-cols-[repeat(auto-fit,226.5px)] justify-center pt-30 max-[429px]:grid-cols-[repeat(auto-fill,170px)] max-md:grid-cols-[repeat(auto-fill,199px)] max-md:px-4`,
              )}
            >
              {logos.map((item, index) => (
                <div
                  key={index}
                  className="relative flex h-[130px] items-center justify-center border border-solid border-white"
                >
                  <Image
                    src={`${item.logo.url}?fm=webp`}
                    alt={item.name || ""}
                    width={item.logo.width}
                    height={item.logo.height}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="flex">
              {Array.from({ length: 2 }, (_, index) => (
                <div key={index}>
                  <div
                    className={cn(
                      cssClass,
                      `animate-infinite-scroll grid auto-cols-[258px] grid-flow-col gap-4 overflow-x-auto pt-30 max-md:grid-rows-3`,
                    )}
                  >
                    {logos.map((item, index) => (
                      <div
                        key={index}
                        className="relative mb-2 flex h-[130px] w-[258px] items-center justify-center"
                      >
                        <Image
                          src={`${item.logo.url}?fm=webp`}
                          alt={item.name || ""}
                          width={item.logo.width}
                          height={item.logo.height}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </GridItem>
    </Grid>
  );
};

export default LogoList;
